/* eslint-disable */
import * as React from "react";

import { ReportRenderer, useParameter } from "../../../shared";
import { ReportToolbarGroup } from "../../../components/ReportToolbar";
import { ReportGrid } from "../../../components/ReportGrid";

import { CommoditiesControl } from "../controls/CommoditiesControl";
import { ForecastSourcesControl } from "../controls/ForecastSourcesControl";

import { useSubscription } from "./useSubscription";

export default function () {
  const [commodity] = useParameter<number>("@commodities");

  useSubscription();
  return (
    <>
      <ReportToolbarGroup>
        <CommoditiesControl />
        <ForecastSourcesControl key={commodity || undefined} />
      </ReportToolbarGroup>
      <div style={{ display: "none" }}>
        <ReportGrid>
          <ReportRenderer componentId="chart-historical" />
          <ReportRenderer componentId="chart-forecast" />
        </ReportGrid>
      </div>
    </>
  );
}
